import { render, staticRenderFns } from "./NoReply.vue?vue&type=template&id=b89ab5a4&"
import script from "./NoReply.vue?vue&type=script&lang=js&"
export * from "./NoReply.vue?vue&type=script&lang=js&"
import style0 from "./NoReply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports